import { getStaticAssetUrl } from 'utils/url';
import { UserTotalBalance } from 'structure/pv2/dynavault/components/UserTotalBalance';
import React from 'react';
import { useUserTotalStakeAssets } from 'structure/pv2/vault/hooks/useUserTotalStakeAssets';
import { Body2, Header3, Header4, Title4 } from 'components/Typography';
import { useStakingPoolList } from 'structure/staking/hooks/useStakingAPI';
import { sumStakingTvlUsd } from 'structure/staking/utils/stakingTvl';
import { formatUsd } from '@dapp/multi-lib/lib/formatters';
import { useConnection } from 'wagmi';
import { useTranslation } from 'react-i18next';

const MultiAssetHeader = ({ title }: { title: string }) => {
  const assetsQuery = useUserTotalStakeAssets();
  const stakingPoolListQuery = useStakingPoolList();
  const connection = useConnection();
  const { t } = useTranslation('common');

  const totalTvl = sumStakingTvlUsd(stakingPoolListQuery.data);

  return (
    <div
      className='rounded-main mt-8 w-full border border-[#191A1E] bg-cover bg-top px-6 py-9 max-lg:mt-0 lg:px-10'
      style={{
        backgroundImage: `url(${getStaticAssetUrl('/sfi/static/pv2/block_cave.jpeg)')}`,
      }}
    >
      <Header3 className='text-[1.5rem] font-thin leading-[1.5rem] text-[#F7F8F8] lg:text-[2rem] lg:leading-[2rem]'>
        {title}
      </Header3>
      <div className='mt-8 flex flex-col items-start gap-2'>
        <div className='flex flex-row flex-nowrap items-start gap-4 lg:gap-10'>
          <UserTotalBalance
            balance={String(assetsQuery.data || 0)}
            label='User Balance'
            showConnectionDescription={false}
          />
          <StakingTotalValue totalTvl={totalTvl} />
        </div>
        <Body2 className={connection.isConnected ? 'hidden' : 'text-[#EDFF6D]'}>
          {t('CONNECT_WALLET_DESCRIPTION')}
        </Body2>
      </div>
    </div>
  );
};

const StakingTotalValue = ({ totalTvl }: { totalTvl: number }) => (
  <div className='flex flex-col items-start gap-2 self-start'>
    <Title4 className='text-[1rem] font-thin leading-[1rem] text-[#B5B5B5] lg:text-[1.25rem] lg:leading-[1.25rem]'>
      TVL:
    </Title4>
    <Header4 className='text-[1.625rem] leading-[1.625rem] text-white lg:text-[2.25rem] lg:leading-[2.25rem]'>
      ${formatUsd(totalTvl)}
    </Header4>
  </div>
);

// eslint-disable-next-line import/no-default-export
export default MultiAssetHeader;
